







































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// @ts-ignore hack
import EchartOption from '@root/common/const/e-chart-options';
// @ts-ignore hack
import * as api from '@/api/business-overview';
import { commaNumber } from '../format';

@Component
export default class TodayDischarge extends Vue {
  commaNumber: Function = commaNumber;
  @Prop({ default: 0 })
  type?: number;
  @Prop()
  orgIds?: Array<String>;
  @Prop()
  parkId?: String;

  @Watch('orgIds')
  @Watch('parkId')
  onOrgChange() {
    this.fetchTableData(this.page.current);
    // this.fetchChartData()
  }

  inChartOption: EchartOption = new EchartOption();
  inChartData: boolean = true;

  outChartOption: EchartOption = new EchartOption();
  outChartData: boolean = true;

  // xAxisData: string[] = ['0时','1时','2时', '3时', '4时', '5时', '6时', '7时', '8时', '9时', '10时', '11时', '12时',
  //   '13时', '14时', '15时', '16时', '17时', '18时', '19时', '20时', '21时', '22时', '23时', '12时']
  inTotal: number | null = null;
  outTotal: number | null = null;
  inDataX: string[] = [];
  inData: number[] = [];
  outDataX: string[] = [];
  outData: number[] = [];

  get columns() {
    return this.type == 1
      ? [
          {
            title: '排名',
            dataIndex: 'rank',
            customRender: (text: any, record: any, index: number) => {
              return index + 1 + (this.page.current - 1) * this.page.pageSize;
            }
          },
          {
            title: '通道名称',
            dataIndex: 'channelName'
          },
          {
            title: '通道类型名称',
            dataIndex: 'channelTypeName'
          },
          {
            title: '进场数',
            dataIndex: 'num',
            align: 'right',
            sorter: (a: { num: number }, b: { num: number }) => a.num - b.num
          }
        ]
      : [
          {
            title: '排名',
            dataIndex: 'rank',
            customRender: (text: any, record: any, index: number) => {
              return index + 1 + (this.page.current - 1) * this.page.pageSize;
            }
          },
          {
            title: '车场名称',
            dataIndex: 'name'
          },
          {
            title: '进场',
            dataIndex: 'enterNum',
            align: 'right',
            sorter: (a: { enterNum: number }, b: { enterNum: number }) => a.enterNum - b.enterNum
          },
          {
            title: '出场',
            dataIndex: 'exitNum',
            align: 'right',
            sorter: (a: { exitNum: number }, b: { exitNum: number }) => a.exitNum - b.exitNum
          }
        ];
  }
  page: any = {
    current: 1,
    pageSize: 5,
    total: 0
  };
  tableData: any[] = [];
  tableLoading: boolean = false;

  onTableChange(pagination: { current: any }) {
    this.fetchTableData(pagination.current);
  }

  get title() {
    return {
      show: false
    };
  }

  get grid() {
    return {
      show: false,
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  }

  get xAxisIn() {
    return {
      type: 'category',
      boundaryGap: true,
      axisLabel: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      data: this.inDataX
    };
  }

  get xAxisOut() {
    return {
      type: 'category',
      boundaryGap: true,
      axisLabel: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      data: this.outDataX
    };
  }

  get yAxis() {
    return [
      {
        type: 'value',
        axisLabel: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      }
    ];
  }

  get inSeries() {
    return [
      {
        name: '进场',
        type: 'line',
        smooth: true,
        showSymbol: false,
        lineStyle: {
          color: '#03a9f4'
        },
        areaStyle: {
          color: '#03a9f4',
          opacity: 0.2
        },
        data: this.inData
      }
    ];
  }

  get outSeries() {
    return [
      {
        name: '出场',
        type: 'line',
        smooth: true,
        showSymbol: false,
        lineStyle: {
          color: '#00bcd4'
        },
        areaStyle: {
          color: '#00bcd4',
          opacity: 0.2
        },
        data: this.outData
      }
    ];
  }

  public async fetchTableData(page: any) {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      let result;
      if (this.type == 0) {
        result = await api.queryGroupTodayDischargeList({
          currPage: page,
          pageSize: this.page.pageSize,
          orgIds: this.orgIds
        });
      } else {
        result = await api.queryParkTodayDischargeList({
          currPage: page,
          pageSize: this.page.pageSize,
          parkId: this.parkId
        });
      }
      const { status, msg, code, data } = result;
      this.inTotal = data.enterNum;
      this.outTotal = data.exitNum;
      this.inDataX = data.enterTabe.map((i: { time: string }) => i.time + '时');
      this.inData = data.enterTabe.map((i: { num: any }) => i.num);
      this.outDataX = data.exitTabe.map((i: { time: string }) => i.time + '时');
      this.outData = data.exitTabe.map((i: { num: any }) => i.num);
      if (data) {
        const { currPage, totalPage, datas = [] } = data.data;
        this.tableData = datas;
        this.page.current = currPage;
        this.page.total = this.currPage * this.totalPage;
      }
    } catch (error) {
      this.tableData = [];
    } finally {
      this.tableLoading = false;
      this.refreshChart();
    }
  }

  // public async fetchChartData() {
  //   try {
  //     const { status, msg, code, data } = await api.queryTodayDischargeChart({
  //       orgDepId: this.orgDepId,
  //     })
  //     this.inData = data.inData
  //     this.outData = data.outData
  //     this.refreshChart()
  //   } catch (error) {
  //     this.tableData = []
  //   }
  // }

  refreshChart() {
    const inChartOption: EchartOption = new EchartOption();
    inChartOption.setLegend({ show: false });
    inChartOption.setGrid(this.grid);
    inChartOption.setXAxis(this.xAxisIn, true);
    inChartOption.setYAxis(this.yAxis, true);
    inChartOption.setTitle(this.title);
    inChartOption.setSeries(this.inSeries);
    this.inChartOption = inChartOption;

    const outChartOption: EchartOption = new EchartOption();
    outChartOption.setLegend({ show: false });
    outChartOption.setGrid(this.grid);
    outChartOption.setXAxis(this.xAxisOut, true);
    outChartOption.setYAxis(this.yAxis, true);
    outChartOption.setTitle(this.title);
    outChartOption.setSeries(this.outSeries);
    this.outChartOption = outChartOption;
  }

  init() {
    this.fetchTableData(this.page.current);
  }

  // 定时刷新
  timer: any;
  mounted() {
    this.init();

    this.timer = setInterval(() => {
      this.init();
    }, 300000);
  }
  destroyed() {
    clearInterval(this.timer);
  }
}
